// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"44":"d4bbcbd2e7144ca32d45","465":"140d7ce03f37286809c1"}[chunkId] + ".bundle.js";
};